let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("kfrgo")).then(() => parcelRequire('2Z7LQ'));